



















import PageMixin from '@/mixins/page-mixin';
import DatajobServices from '@/services/datajob';
import { mixins } from 'vue-class-component';
import { Vue, Component } from 'vue-property-decorator';
import JobRecordFilter from '../../components/data/datajob-record-filter.vue';
import JobList from '../../components/data/datajob-record-list.vue';
@Component({
  components: { JobRecordFilter, JobList }
})
export default class Job1 extends mixins(PageMixin) {
  bread = [{ name: '作业运行管理' }, { name: '数据管理作业' }];
  jobSrv = new DatajobServices();

  created() {
    this.getList();
  }

  list: any[] = [];
  async getList() {
    this.loading = true;
    let query = this.$route.query || {};
    let params = { ...this.filter, ...query, page: this.page, limit: this.limit };
    let res: any = await this.jobSrv.getLogPageList(params);
    this.list = res.data;
    this.total = res.recordsTotal;
    this.loading = false;
  }
}
